import { useFormStore } from '@/stores/form'
import dropdownApi from '@/services/dropdowns'
import { DateTime } from 'luxon'

export default async function () {
  try {
    const res = await dropdownApi.fetchEstablishmentInfo()
    const formStore = useFormStore()
    if (res) {
      formStore.draft.request = {
        ...formStore.draft.request,
        ...{
          englishName: res.englishName,
          arabicName: res.arabicName,
          departmentText: res.department.text,
          sponsorTypeText: res.sponsorType.text,
          licenseIssueDate:
            res.licenseIssueDate &&
            DateTime.fromJSDate(new Date(res.licenseIssueDate)).toFormat('dd/MM/yyyy'),
          number: res.number
        }
      }
    }
  } catch (error) {
    console.error('fetchEstablishmentInfo error: ', error)
  }
}
